module.exports = __webpack_public_path__ + "static/media/auto-background.144d3744.svg";